module.exports = __webpack_public_path__ + "liya-429d2be8cea6414bfc71c507a98abbfa.webp";